var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpenIcon = function SvgEyeOpenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.002 11C5.03 11 2.048 7.778 1.064 6c.984-1.777 3.965-5 8.938-5 2.598 0 4.685.875 6.214 1.969 1.417 1.013 2.334 2.198 2.733 3.015C17.975 7.758 14.991 11 10.002 11m0-11C4.33 0 1.015 3.827.052 5.779a.5.5 0 0 0 0 .442c.963 1.952 4.278 5.78 9.95 5.78 5.673 0 8.988-3.828 9.951-5.78a.5.5 0 0 0 .014-.411c-.419-1.02-1.505-2.465-3.17-3.655C15.123.957 12.836 0 10.003 0M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
export default SvgEyeOpenIcon;